import { inject, Injectable } from '@angular/core';
import {
  AdobeDataLayerPayload,
  AdobeDataPages,
} from '../models/adobe-data-layer.model';
import { MlbStatsConnectionService } from './mlb-stats.service';
import { ConfigurationService } from './configuration.service';
import { lastValueFrom, Subject } from 'rxjs';
import { SaleEvent } from '@core/models';
import { environment } from '@environments/environment';
import { SeatManagementService } from '@features/digital-venue/services/seat-management.service';

@Injectable({
  providedIn: 'root',
})
export class CartRestorerService {
  seats: { id: string; original_id: string }[] = [];
  seatManagementService = inject(SeatManagementService);
  sectionId: string;

  saveSelectedSeatsAndSection(seats: { id: string; original_id: string }[]) {
    console.log('[CartRestorerService.saveSelectedSeats] seats', seats);
    this.sectionId = seats[0]?.id?.split('-')[0];
    this.seats = seats;
  }

  getSelectedSeats() {
    console.log('[CartRestorerService.getSelectedSeats] seats', this.seats);
    return this.seats || [];
  }

  restoreSelectedSeats() {
    const selectedSeats = this.getSelectedSeats();
    if (selectedSeats.length > 0) {
      this.seatManagementService.selectAvailableSeats(selectedSeats);
    }
  }
}
